import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $insertNodeToNearestRoot } from "@lexical/utils";
import {
  COMMAND_PRIORITY_EDITOR,
  createCommand,
  LexicalCommand,
} from "lexical";
import { useEffect } from "react";

import { $createSearchFormNode, SearchFormNode } from "../nodes/SearchFormNode";

export const INSERT_SEARCH_FORM_COMMAND: LexicalCommand<string> = createCommand(
  "INSERT_SEARCH_FORM_COMMAND"
);

export default function SearchFormPlugin(): JSX.Element | null {
  const [editor] = useLexicalComposerContext();

  // 現在挿入時の設定ダイアログは無し

  useEffect(() => {
    if (!editor.hasNodes([SearchFormNode])) {
      throw new Error(
        "SearchFormPlugin: SearchFormNode not registered on editor"
      );
    }

    return editor.registerCommand<string>(
      INSERT_SEARCH_FORM_COMMAND,
      () => {
        const lineLinkNode = $createSearchFormNode();
        $insertNodeToNearestRoot(lineLinkNode);

        return true;
      },
      COMMAND_PRIORITY_EDITOR
    );
  }, [editor]);

  return null;
}
